import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { parseIsoDateOrTimestamp } from '../../../../Timestamp/functions';
import s from './AdoptableCardStats.scss';
const AdoptableCardStats = ({ deviation  })=>{
    var _deviation_adoptable, _deviation_adoptable1;
    const { t  } = useTranslation();
    const { numOffers , offerEndTime  } = ((_deviation_adoptable = deviation.adoptable) === null || _deviation_adoptable === void 0 ? void 0 : _deviation_adoptable.offers) || {};
    const thumbSaleState = ((_deviation_adoptable1 = deviation.adoptable) === null || _deviation_adoptable1 === void 0 ? void 0 : _deviation_adoptable1.thumbSaleState) || '';
    const toDate = parseIsoDateOrTimestamp(offerEndTime);
    const daysLeft = useMemo(()=>{
        const msPerDay = 1000 * 60 * 60 * 24;
        return Math.ceil((toDate.getTime() - Date.now()) / msPerDay);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if ([
        'sold',
        'unlisted',
        'expired'
    ].includes(thumbSaleState)) {
        return null;
    }
    const timesUp = toDate.getTime() < Date.now();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, daysLeft > 0 && /*#__PURE__*/ React.createElement("span", null, t('shop.thumb.adoptable.daysLeft', {
        count: daysLeft
    })), timesUp && /*#__PURE__*/ React.createElement("span", {
        className: s['warning']
    }, t('shop.thumb.adoptable.timesUp')), !!numOffers && /*#__PURE__*/ React.createElement("span", null, t('common.offerCount', {
        count: numOffers
    })));
};
AdoptableCardStats.displayName = 'AdoptableCardStats';
export default AdoptableCardStats;
